import React from "react";
import { Stack, Typography } from "@mui/material";

import { PagePrint } from "../PagePrint";
import { PageMarker } from "../PageMarker";

import Header from "../VendorTerms/Header.png";
import LogoBackground from "../VendorTerms/LogoBackground.png";
import { QUOTE_TERMS_LIST } from "../../constants/quoteTerms";

import { StyledHeader, StyledWatermark, StyledPageContent } from "./styles";

const QuoteTermsPage = () => {
  return (
    <PagePrint cardProps={{ id: "page-3", sx: { position: "relative" } }}>
      <Stack width="100%" height="100%">
        <StyledPageContent>
          <Typography
            variant="boldCaptionL"
            textAlign="center"
            fontSize={16}
          >
            IPC Foundry Group Quotation Terms & Conditions:
          </Typography>
          <Stack gap="10px">
            {QUOTE_TERMS_LIST.map((term, idx) => (
              <Stack key={idx}>
                <Typography variant="boldCaptionL" fontSize={13}>
                  {idx + 1}.{" "}
                  <Typography
                    component="span"
                    fontSize={13}
                    fontWeight={700}
                  >
                    {term.title}
                  </Typography>
                </Typography>
                <Typography
                  variant="caption"
                  fontSize={12}
                  lineHeight="15px"
                >
                  {term.label}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </StyledPageContent>
        <StyledHeader component="img" src={Header} />
        <StyledWatermark component="img" src={LogoBackground} />
        <PageMarker page={2} pages={2} />
      </Stack>
    </PagePrint>
  );
};

export default QuoteTermsPage;
